import Phaser from 'phaser'
import Config from '../launch/config'
import Matter from 'matter-js'
import {saveGame} from '../launch/store'
import audio from '../launch/audio'

export default function orbit() {
    const body = this.sprite.body

    this.orbitGraphics && this.orbitGraphics.clear()

    if (!this.orbitingEntity) {
        return
    }

    if (!this.enteringOrbit) {
        this.enteringOrbit = true

        if (this.faction === Config.userFactionName) {
            saveGame(`${this.name} enter orbit`)
            audio.shipEnterOrbit()
        }

        // Stop Ship
        Matter.Body.setVelocity(body, {
            x: 0,
            y: 0,
        })

        // Ship is orbiting
        if (this.orbitingEntity) {
            // this.thrustEmitter && this.thrustEmitter.stop()

            // Assign ship to entity orbitables
            this.orbitingEntity.orbitingShips[this.id] = {
                faction: this.faction,
                isDetected: this.isDetected,
                type: this.type,
            }

            // Clear ship move line
            // this.moveLineGraphics && this.moveLineGraphics.destroy()

            // If ship orbits star, detach towable
            if (this.orbitingEntity.type !== 'planet') {
                this.detachTowables()
            }
        }

        // Add this sprite to orbit group and create point
        this.orbitGroup = Config.scene.add.group()
        this.orbitGroup.add(this.sprite, false)
        this.orbitPoint = new Phaser.Geom.Point(
            this.orbitingEntity.x,
            this.orbitingEntity.y
        )
    }

    // Rotate orbit group children around point
    Phaser.Actions.RotateAroundDistance(
        this.orbitGroup.getChildren(),
        this.orbitPoint,
        this.orbitSpeed,
        Config.orbitDistance
    )

    // Point ship in direction
    // Matter.Body.setAngularVelocity(body, 0.008)
    Matter.Body.setAngle(body, (this.orbitAngle -= 0.006))

    // this.orbitAngle += 0.002
    // Matter.Body.setAngle(body, this.orbitAngle)
    // Matter.Body.setVelocity(body, {
    //     x: Math.cos(this.orbitAngle),
    //     y: Math.sin(this.orbitAngle),
    // })
}
